<template>
  <!-- DESKTOP SIDEBAR Store: CD-3 -->
  <transition name="slide-left">
    <aside
      class="fixed left-0 top-16 bottom-0 z-50 bg-white shadow-xl flex flex-col mt-2 transition-all duration-300 ease-in-out border border-gray-200"
      :class="open ? 'w-[312px]' : 'w-[80px]'"
      v-show="true"
    >
      <div class="flex-1 overflow-y-auto px-2 py-4 text-sm pl-2">
        <SidebarItem
          v-for="value in menuItems"
          :key="value.label"
          :icon="value.icon"
          :label="value.label"
          :collapsed="!open"
          @click="navigateTo(value.to)"
          :class="isActive(value.to) ? `${activeOpenRouteStyle(open)}` : `${inactiveRouteStyle(open)}`"
        />
      </div>

      <div class="px-2 pb-4 text-sm pl-2 py-3">
        <SidebarItem
          v-for="value in bottomLinks"
          :key="value.label"
          :icon="value.icon"
          :label="value.label"
          :collapsed="!open"
          @click="navigateTo(value.to)"
          :class="isActive(value.to) ? `${activeOpenRouteStyle(open)}` : `${inactiveRouteStyle(open)}`"
        />
      </div>

      <div class="flex justify-center">
        <hr class="border-gray-200" :class="open ? 'w-[280px]' : 'w-[50px]'" />
      </div>
      <div class="flex items-center justify-between px-6 py-6 text-xs">
        <div v-if="open" class="flex flex-col">
          <span class="font-medium text-gray-900">{{ fullName }}</span>
          <span class="text-gray-500">{{ email }}</span>
        </div>

        <button class="p-2 rounded hover:bg-gray-100" @click="emit('sign-out')">
          <LogOut class="w-4 h-4 text-gray-600" />
        </button>
      </div>
    </aside>
  </transition>
</template>

<script setup lang="ts">
import SidebarItem from '@/components/shopper/SidebarItem.vue';
import { LogOut } from 'lucide-vue-next';
import { useRoute, useRouter } from 'vue-router';

defineProps<{ open: boolean; fullName: string; email: string }>();
const emit = defineEmits(['close', 'sign-out']);
const router = useRouter();
const route = useRoute();

const menuItems = [
  { label: 'Home', icon: 'Home' as const, to: '/shopper' },
  { label: 'Boost Rewards', icon: 'Boost' as const, to: '/shopper/boost-rewards' },
  { label: 'Lay-by', icon: 'CreditCardIcon' as const, to: '/shopper/lay-by' },
  { label: 'Subscriptions', icon: 'Subscription' as const, to: '/shopper/subscriptions' },
  { label: 'Stores', icon: 'Store' as const, to: '/shopper/stores' },
];

const bottomLinks = [
  { label: 'Help Center', icon: 'HelpCircleIcon' as const, to: '/shopper/help-center' },
  { label: 'Contact Us', icon: 'Phone' as const, to: '/shopper/contact-us' },
];

const navigateTo = (path: string) => {
  router.push(path);
};

const isActive = (path: string) => route.path === path;

const activeOpenRouteStyle = (open: boolean) =>
  open
    ? 'bg-gray-50 text-grey-light-800 font-bold pl-4 py-4 rounded-lg h-[48px]'
    : 'bg-gray-50 text-grey-light-800 font-bold pl-0 py-2 rounded-lg h-[48px] w-[48px]';

const inactiveRouteStyle = (open: boolean) => (open ? 'pl-4 py-4 h-[48px]' : 'pl-0 py-2 h-[48px] w-[48px]');
</script>
